import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { HashRouter } from 'react-router-dom'
import { BrowserRouter } from 'react-router-dom';


import { store } from './_store'
import { ToastProvider } from './_helpers/ToastContext'
import { setupAxiosInterceptors } from './_helpers/api'

const container = document.getElementById('root')
const root = createRoot(container)
setupAxiosInterceptors()

root.render(
  <Provider store={store}>
    <ToastProvider>
      <HashRouter>
        <App />
      </HashRouter>
    </ToastProvider>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
